import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconTriangle = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--triangle")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M9.88015153,3.44887293 C10.4268674,2.54753799 11.3993897,2 12.4480189,2 C13.4966482,2 14.4691705,2.54753799 15.0158864,3.44887293 L23.4940095,17.6026836 C24.027047,18.5257831 24.0302296,19.662404 23.5023697,20.5884739 C22.9745098,21.5145439 21.9948915,22.0909683 20.9180189,22.102744 L3.96702842,22.102744 C2.90114644,22.0909683 1.92152808,21.5145439 1.3936682,20.5884739 C0.865808319,19.662404 0.86899086,18.5257831 1.41015153,17.5888729 L9.88015153,3.44887293 Z M3.13400948,18.6028044 C2.95633029,18.9105042 2.95526945,19.2893779 3.13122274,19.5980678 C3.30717603,19.9067578 3.63371549,20.0988993 3.97801895,20.1028044 L20.9070284,20.1028044 C21.2623224,20.0988993 21.5888619,19.9067578 21.7648152,19.5980678 C21.9407685,19.2893779 21.9397076,18.9105042 21.7701515,18.6166151 L13.3030189,4.481372 C13.1217361,4.18251266 12.797562,4 12.4480189,4 C12.0992423,4 11.7757234,4.1817132 11.5942134,4.47940787 L3.13400948,18.6028044 Z" id="icon--centivo--triangle"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-282.000000, -1312.000000)"/>
          <g id="Icon/triangle">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--triangle"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--triangle"/>
          </g>
      </g>
  </IconWrapper>
)
